import * as React from 'react';
import { forwardRef } from 'react';
const LabelPairedSquareSmBoldIcon = ({ title, titleId, ...props }, ref) => (React.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: 13, height: 22, viewBox: '0 0 13 22', role: 'img', ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", null,
        React.createElement("path", { d: 'M10.875 5.938h-8.75a.45.45 0 0 0-.437.437v8.75c0 .246.19.438.437.438h8.75a.45.45 0 0 0 .438-.438v-8.75a.47.47 0 0 0-.438-.437m-8.75-1.313h8.75c.957 0 1.75.793 1.75 1.75v8.75c0 .984-.793 1.75-1.75 1.75h-8.75c-.984 0-1.75-.766-1.75-1.75v-8.75c0-.957.766-1.75 1.75-1.75' })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: '3aee50af01a73632bbfc69cef77b8423__a' },
            React.createElement("path", { d: 'M0 0h13v22H0z' })))));
const ForwardRef = forwardRef(LabelPairedSquareSmBoldIcon);
export default ForwardRef;
